<template>
       <div id="credentials" class="credentials jumbotron d-flex justify-content-center container-fluid bg-white">
           <div class="row w-100">
             <div class="col-12 text-center m-2">
              <h1 class="mb-5">Our Credentials</h1>
            </div>
               <div v-for="(skill, index) in credentials" :key="index" class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-3">
                   <div class="card custom-card">
                    <div class="card-header custom-card-header bg-white">
                      <h4>{{skill.title}}</h4>
                    </div>
                   <div class="card-body custom-card-body" v-html="skill.content"></div>
                   </div>
               </div>
               <div class="technologies d-flex justify-content-center align-items-center col-12 mt-5">
                <div class="lang-logos col-6 col-sm-6 col-md-4 col-lg-2"><img class="img-fluid" src="../assets/img/lang_java.svg"></div>
                <div class="lang-logos col-6 col-sm-6 col-md-4 col-lg-2"><img class="img-fluid" src="../assets/img/lang_php.svg"></div>
                <div class="lang-logos col-6 col-sm-6 col-md-4 col-lg-2"><img class="img-fluid" src="../assets/img/lang_ruby.svg"></div>
                <div class="lang-logos col-6 col-sm-6 col-md-4 col-lg-2"><img class="img-fluid" src="../assets/img/lang_javascript.svg"></div>
                <div class="lang-logos col-6 col-sm-6 col-md-4 col-lg-2"><img class="img-fluid" src="../assets/img/lang_docker.svg"></div>
                <div class="lang-logos col-6 col-sm-6 col-md-4 col-lg-2"><img class="img-fluid" src="../assets/img/lang_kubernetes.png"></div>
               </div>
           </div>
        </div>
</template>

<script>
export default {
    name: 'OurCredentials',
    data(){
        return {
            credentials: [
                {
                    title: 'Our experience',
                    content: `<ul class="credentials-list">
                           <li>20 years of accumulated experience.</li>
                           <li>Delivery of products with the highest standards.</li>
                           <li>Experience of implementing solutions for small and large companies in the US.</li>
                           <li>Security through  an OWASP approach standards.</li>
                           <li>Agile methodologies.</li>
                       </ul>`,
                },
                {
                    title: 'Professional certifications',
                    content: `<ul class="credentials-list">
                           <li>Scrum Master.</li>
                           <li>Devops Essentials Professional Certificate (DEPC).</li>
                           <li>Microsoft Web Developments Fundamentals.</li>
                       </ul>`,
                },
                {
                    title: 'Programming languages',
                    content: `<ul class="credentials-list">
                           <li>Java</li>
                           <li>PHP</li>
                           <li>Ruby</li>
                           <li>JavaScript</li>
                           <li>Docker</li>
                           <li>Kubernetes</li>
                       </ul>`,
                },
                {
                    title: 'Mastery of software tools',
                    content: `<ul class="credentials-list">
                           <li>Frameworks: Hibernate, JPA, Spring, Laravel, Yii2, Ruby on Rails, JSF.</li>
                           <li>Application servers: Jboss, Tomcat, Weblogic.</li>
                           <li>JavaScript technologies: JQuery, Vue, Angular and React.</li>
                           <li>Various technologies: Xquery, Oracle Service Bus, WSDL, REST.</li>
                       </ul>`,
                }
            ]
        }
    }
}
</script>

<style>

</style>